import { Form, FormField, FormSection, FormType } from '../../../../common/components/reactive-form-builder/interfaces/form.interface';
import { ClientesEnvironmentDefinition } from '../environment-variables';
import { ClientesListsDefinition } from './list-variables';
import { StorageManager } from '../../../../common/storage-manager.class';
import { FormRequestTypes } from '../../../../common/components/reactive-form-builder/form-request';
import { InputType } from '../../../../common/components/reactive-form-builder/interfaces/input.interface';
import { FilteredValuesInterface } from '../../../../common/components/form-builder/form-builder.component';
import { list } from '../../../../common/classes/request-builder';
import { environment } from '../../../../../environments/environment';
import { UserModel } from '../../../../models/usuarios/user.model';
import { ClienteModel } from '../../../../models/cliente.model';
import {  
  FIRST_CHAR_UNION 
} from '../../../../common/components/reactive-form-builder/utils/spanish-id.keyfilter';

export class ClientesFormDefinition {    
  public formType!: FormType;

  public env: ClientesEnvironmentDefinition = new ClientesEnvironmentDefinition();

  public lists: ClientesListsDefinition = new ClientesListsDefinition();

  public usuario = StorageManager.getUser();

  public model: ClienteModel = {} as ClienteModel;
    
  public formFieldsSection!: FormSection<object>;

  public formFieldsPrevilsa1!: FormSection<object>;

  public formFieldsPrevilsa2!: FormSection<object>;

  public formFieldsEstadosReglas!: FormSection<object>;
    
  public formFields!: Form<ClienteModel>;

  public fieldNames: FormField<any>[] = [];

  public fieldLabels: string[] = [];

  public spanishIdKeyPattern: RegExp = FIRST_CHAR_UNION;

  constructor(
    type: FormRequestTypes, 
    _model: Record<string,string>,
    table: (string[] | string[][])[] | null
  ) {
    this.formType = +type;
        
    const action = this.formType === FormType.CREATION ? 'Crear' : 'Actualizar';

    this.formFields = {
      name: 'clientes',
      header: action + ' ' + this.env.clienteName,
      type: this.formType,
      sections: this.getFormSections(),
      table: { title: '', showIndex: false, data: table?.[0], style: table?.[1]},
      uploadButton: {isEnabled: false, label: ''},
      signed: this.env.showClientesFirma
    };
  }


  public getFormFields(): FormField<any>[] {
    const standardCodeLength = 45;

    const prosanzcuCodeLength = 3;
    
    const formFields: FormField<any>[] = [
      {
        name: 'nombre', 
        vinculatedFields: undefined,
        label: 'Nombre o Razón Social',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 1
      },
      {
        name: 'apellido_1', 
        vinculatedFields: undefined,
        label: 'Primer Apellido', 
        input: {isEditable: true, type: InputType.TEXT}, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 2
      },
      {
        name: 'apellido_2', 
        vinculatedFields: undefined,
        label: 'Segundo Apellido', 
        input: {
          isEditable: true, 
          type: InputType.TEXT
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 3,
      },
      {
        name: 'nif',
        vinculatedFields: undefined, 
        label: 'NIF / CIF', 
        input: {
          isEditable: true,
          type: InputType.TEXT,
          maxLength: 9,
          textConfiguration: {
            regex: this.spanishIdKeyPattern
          }
        },
        updateValue: (it: any): void => {
          const input = it.input;
          const textCfg = (input.textConfiguration ??= {});

          textCfg.regex = this.spanishIdKeyPattern;     
        },
        checkForDuplicates: (nif: string) => this.env.appName !== 'innovia' ? (this.lists.clientes.values ?? []).some(opt => {
          const row = (opt?.value as ClienteModel) ?? undefined;

          if (this.model.id != null && row?.id.toString() === this.model.id.toString()) {return false;}

          return row?.nif === nif;
        }) : false,
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: this.env.activateREA || this.env.appName === 'innovia',
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 4,
      },
      {
        name: 'sector', 
        vinculatedFields: undefined,
        label: 'Sector', 
        input: {isEditable: true, type: InputType.TEXT}, 
        width: 4,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'crm'
        },
        order: 5,
      },
      {
        name: 'cooperativa', 
        vinculatedFields: undefined,
        label: 'Cooperativa', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: true,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showClientesCooperativa
        },
        order: 6
      },
      {
        name: 'codigo',
        vinculatedFields: undefined,
        label: this.env.appName === 'prodalbar' ? 'Nº Socio' :'Código',  
        input: {
          isEditable: true, 
          maxLength: this.env.appName === 'prodalbar' ? prosanzcuCodeLength : standardCodeLength,
          type: InputType.TEXT
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasCodigoCliente
        },
        order: 7
      },
      {
        name: 'alias',
        vinculatedFields: undefined,
        label: this.env.appName === 'covidai' ? 'Almacén' : 'Alias',  
        input: {
          isEditable: true, 
          data: this.lists.almacenesCovidai,
          type: InputType.DROPDOWN
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.hasClientesAliasField
        },
        order: 8
      },
      {
        name: 'direccion',
        vinculatedFields: undefined,
        label: 'Dirección', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 9
      },
      {
        name: 'localidad',
        vinculatedFields: undefined,
        label: 'Localidad', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 10
      },
      {
        name: 'codigo_postal', 
        vinculatedFields: undefined,
        label: 'Codigo Postal', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 11
      },
      {
        name: 'provincia', 
        vinculatedFields: undefined,
        label: 'Provincia', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 12
      },
      {
        name: 'municipio_ine', 
        vinculatedFields: undefined,
        label: 'Código Municipio INE',
        input: {isEditable: true, type: InputType.TEXT}, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showReto
        },
        order: 13
      }, 
      {
        name: 'ropo',
        vinculatedFields: undefined,
        label: 'Nº ROPO SU',  
        input: {isEditable: true, type: InputType.TEXT}, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showReto
        },
        order: 14
      },                   
      {
        name: 'telefono', 
        vinculatedFields: undefined,
        label: 'Teléfono', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 15
      },
      {
        name: 'fax',
        vinculatedFields: undefined,
        label: 'Fax',  
        input: {isEditable: true, type: InputType.TEXT}, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showReto
        },
        order: 16
      },          
      {
        name: 'email',
        vinculatedFields: undefined,
        label: 'Email', 
        input: {
          isEditable: true, 
          type: InputType.TEXT,
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 17
      },
      {
        name: 'gerente',
        vinculatedFields: undefined,
        label: 'Gerente',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 18
      },
      {
        name: 'email_gerente',
        vinculatedFields: undefined,
        label: 'Email del Gerente',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 19
      },
      {
        name: 'telefono_gerente',
        vinculatedFields: undefined,
        label: 'Teléfono del Gerente',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 20
      },
      {
        name: 'responsable_calidad',
        vinculatedFields: undefined,
        label: 'Responsable de Calidad',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 21
      },
      {
        name: 'email_responsable_calidad',
        vinculatedFields: undefined,
        label: 'Email del Responsable de Calidad',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 22
      },
      {
        name: 'telefono_responsable_calidad',
        vinculatedFields: undefined,
        label: 'Teléfono del Responsable de Calidad',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showCrm
        },
        order: 23
      },
      {
        name: 
          (this.formType !== FormType.INFORMATIVE && this.formType !== FormType.EXPORT ) ? 
            'id_usuario_asignado' : 
            'usuario_asignado_nombre',
        vinculatedFields: undefined,
        label: this.env.appName === 'crm' ? 'Comercial Asignado' : 'Técnico/Aplicador Asignado',
        input: {
          isEditable: true,
          data: this.lists.usuarios,
          defaultValue: StorageManager.getUser().id,
          type: this.env.appName === 'agrosalvi' || 
                        environment.features.showMultiselectAplicadores ? 
            InputType.MULTISELECT : 
            InputType.DROPDOWN,
          dropdownConfiguration: {
            valuePrimaryKey: 'id',
            filter: (usuario: FilteredValuesInterface<UserModel>): boolean => {
              if (this.env.applicationType === 'cropgest') {
                return usuario.value?.rol === 'responsable';
              } else {
                return true;
              }// if();
            },
          }
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showTecnicoAsignado
        },
        order: 23
      },
      {
        name: 'operador_explotacion',
        vinculatedFields: undefined, 
        label: 'Nº Operador explotación',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'pyf'
        },
        order: 24
      },
      {
        name: 'regepa',
        vinculatedFields: undefined,
        label: 'REGEPA',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showClientesRegepa
        },
        order: 25
      },
      {
        name: 'observaciones',
        vinculatedFields: undefined,
        label: 'Observaciones',  
        input: {isEditable: true, type: InputType.TEXTAREA},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showClientesObservaciones
        },
        order: 26
      },
      {
        name: 'tipo',
        vinculatedFields: undefined,
        label: 'Tipo',  
        input: {
          isEditable: true, 
          data: this.env.showCrm ?  list(['...', null], 'Afianzado', 'Potencial') : this.lists.tipo,
          type: InputType.DROPDOWN
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.appName === 'agrosalvi' || this.env.showCrm,
        },
        order: 27
      },
      {
        name: 'notas',
        vinculatedFields: undefined,
        label: 'Notas', 
        input: {isEditable: true, type: InputType.TEXTAREA},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showClientesNotas,
        },
        order: 28
      },
      {
        name: 'acceso_plataforma',
        vinculatedFields: undefined,
        label: 'Acceso a Plataforma',  
        input: {isEditable: true, type: InputType.SWITCH}, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.applicationType === 'cropgest' && StorageManager.getUser().rol === 'admin',
        },
        order: 29
      }
    ];

    this.fieldNames = this.fieldNames.concat(formFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(formFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return formFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getPrevilsa1Fields(isSectionVisible: boolean): FormField<any>[] {
    const previlsa1Fields: FormField<any>[] = [
      {
        name: 'persona1',
        vinculatedFields: undefined,
        label: 'Persona de contacto 1', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 1
      },
      {
        name: 'persona2',
        vinculatedFields: undefined,
        label: 'Persona de contacto 2',  
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 2
      },
      {
        name: 'telefono1', 
        vinculatedFields: undefined,
        label: 'Teléfono 1', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 3
      },
      {
        name: 'telefono2', 
        vinculatedFields: undefined,
        label: 'Teléfono 2',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 4
      },
      {
        name: 'cargo1',
        vinculatedFields: undefined,
        label: 'Cargo 1', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 5
      },
      {
        name: 'cargo2', 
        vinculatedFields: undefined,
        label: 'Cargo 2', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 6
      },
    ];

    this.fieldNames = this.fieldNames.concat(previlsa1Fields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(previlsa1Fields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return previlsa1Fields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getPrevilsa2Fields(isSectionVisible: boolean): FormField<any>[] {
    const previlsa2Fields: FormField<any>[] = [
      {
        name: 'grupo_compra',
        vinculatedFields: undefined,
        label: 'Grupo de compra',  
        input: {
          isEditable: true,
          data: this.lists.gruposCompra,
          type: InputType.DROPDOWN
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 1
      },
      {
        name: 'tipo_cliente',
        vinculatedFields: undefined,
        label: 'Tipo de cliente', 
        input: {
          isEditable: true, 
          data: this.lists.tiposCliente,
          type: InputType.DROPDOWN
        }, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 2
      },
      {
        name: 'clase_cliente', 
        vinculatedFields: undefined,
        label: 'Clase de cliente', 
        input: {
          isEditable: true,
          data: this.lists.clasesCliente,
          type: InputType.DROPDOWN
        }, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 3
      },
      {
        name: 'condiciones_venta', 
        vinculatedFields: undefined,
        label: 'Condiciones de venta', 
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 4
      },
      {
        name: 'notas',
        vinculatedFields: undefined,
        label: 'Notas',
        input: {isEditable: true, type: InputType.TEXTAREA},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 5
      },
      {
        name: 'comercial',
        vinculatedFields: undefined, 
        label: 'Comercial',
        input: {isEditable: true, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 6
      },
    ];

    this.fieldNames = this.fieldNames.concat(previlsa2Fields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(previlsa2Fields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return previlsa2Fields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getEstadosReglasFields(isSectionVisible: boolean): FormField<any>[] {
    const estadosReglasFields: FormField<any>[] = [
      {
        name: 'estado', 
        vinculatedFields: undefined,
        label: 'Estado', 
        input: {
          isEditable: true,
          data: this.lists.tiposEstado,
          type: InputType.DROPDOWN
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 1
      },
      {
        name: 'regla_negocio', 
        vinculatedFields: undefined,
        label: 'Reglas de negocio', 
        input: {
          isEditable: true,
          data: this.lists.tiposReglaNecogio,
          type: InputType.DROPDOWN
        }, 
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 2
      },  
    ];

    this.fieldNames = this.fieldNames.concat(estadosReglasFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(estadosReglasFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return estadosReglasFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getSDIFields(isSectionVisible: boolean): FormField<any>[] {
    const sdiFields: FormField<any>[] = [
      {
        name: 'nomcli',
        vinculatedFields: undefined,
        label: 'Nombre', 
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 1
      },
      {
        name: 'razon',
        vinculatedFields: undefined,
        label: 'Razón', 
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 2
      },
      {
        name: 'nifcli',
        vinculatedFields: undefined,
        label: 'NIF',  
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 3
      },
      {
        name: 'dircli',
        vinculatedFields: undefined,
        label: 'Dirección', 
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 4
      },
      {
        name: 'dtocli',
        vinculatedFields: undefined,
        label: 'Dto.',  
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 5
      },
      {
        name: 'nomprovi',
        vinculatedFields: undefined,
        label: 'Provincia', 
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 6
      },
      {
        name: 'pobcli',
        vinculatedFields: undefined,
        label: 'Población', 
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 7
      },
      {
        name: 'telcli',
        label: 'Teléfono',
        vinculatedFields: undefined,
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 8
      },
      {
        name: 'email',
        vinculatedFields: undefined,
        label: 'Email',
        input: {isEditable: false, type: InputType.TEXT},
        width: 3,
        conditions: {
          isRememberedOnDuplicate: false,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: isSectionVisible,
        },
        order: 9
      }
    ];

    this.fieldNames = this.fieldNames.concat(sdiFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(sdiFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return sdiFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }

  public getHiddenFields(): FormField<any>[] {
    const hiddenFields: FormField<any>[] = [
      {
        name: 'id',
        vinculatedFields: undefined,
        label: '',
        input: {
          type: InputType.HIDDEN,
          defaultValue: this.model.id,
          isEditable: false
        },
        width: 2,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true,
        },
        order: 1
      },
      {
        name: 'id_usuario',
        vinculatedFields: undefined,
        label: '',
        input: {
          isEditable: false,
          defaultValue: StorageManager.getUser().id,
          type: InputType.HIDDEN,
        },
        updateValue: () => this.model.id_usuario = this.model.id_usuario_asignado ?? this.model.id_usuario ?? '',
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: true
        },
        order: 1
      },
      {
        name: 'id_usuario_asignado2',
        vinculatedFields: undefined,
        label: '',
        input: {
          isEditable: false,
          defaultValue: StorageManager.getUser().id,
          type: InputType.HIDDEN,
        },
        width: 3,
        conditions: {
          isRememberedOnDuplicate: true,
          isRequired: false,
          isRetained: false,
          hasUndoEnabled: false,
          isVisible: this.env.showTecnicoAsignado
        },
        order: 2
      }
    ];

    this.fieldNames = this.fieldNames.concat(hiddenFields.filter((it) => it.conditions.isVisible));
    this.fieldLabels = this.fieldLabels.concat(hiddenFields.filter((it) => it.conditions.isVisible).map(it => it.label));
    return hiddenFields.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
    

  private getFormSections(): FormSection<any>[] {
    const sections: FormSection<any>[] = [
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getFormFields(),
        order: 1
      },
      {
        name: '',
        width: 12,
        isVisible: this.env.appName === 'previlsa',
        fields: this.getPrevilsa1Fields(this.env.appName === 'previlsa'),
        order: 2
      }, 
      {
        name: '',
        width: 12,
        isVisible: this.env.appName === 'previlsa',
        fields: this.getPrevilsa2Fields(this.env.appName === 'previlsa'),
        order: 3
      },
      {
        name: '',
        width: 12,
        isVisible: this.env.showFieldsClientesEstadoReglas,
        fields: this.getEstadosReglasFields(this.env.showFieldsClientesEstadoReglas),
        order: 4
      },
      {
        name: '',
        width: 12,
        isVisible: this.env.showSdiClientes,
        fields: this.getSDIFields(this.env.showSdiClientes),
        order: 4
      },
      {
        name: '',
        width: 12,
        isVisible: true,
        fields: this.getHiddenFields(),
        order: 6
      },
    ];

    return sections.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  }
}